




function open_slider_cart() {
    $(".sn_cart_drawer_holder").addClass("active");
    $(".overlay").addClass("active");
}
function close_slider_cart() {
    $(".sn_cart_drawer_holder").removeClass("active");
    $(".overlay").removeClass("active");

}
function open_slider_search() {
    $(".search_holder").addClass("active");
    $(".overlay").addClass("active");
}
function close_slider_search() {
    $(".search_holder").removeClass("active");
    $(".overlay").removeClass("active");

}
$(".overlay").on("click", function () {
    $(this).removeClass("active");
    $(".search_holder").removeClass("active");
    $(".sn_cart_drawer_holder").removeClass("active");
})


$(document).ready(function () {
    $(".article__bottom-right").each(function () {
        let articleId = $(this).attr("data-article-id"); // Get unique article ID
        let savedPreference = localStorage.getItem("article_opinion_" + articleId); // Unique key

        // Restore previously saved preference
        if (savedPreference === "like") {
            $(this).find(".article__like").addClass("active");
        } else if (savedPreference === "dislike") {
            $(this).find(".article__dislike").addClass("active");
        }
    });

    $(".article__like").on("click", function () {
        let articleId = $(this).closest(".article__bottom-right").attr("data-article-id");

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            localStorage.removeItem("article_opinion_" + articleId);
        } else {
            let parent = $(this).closest(".article__bottom-right");
            parent.find(".article__opinion").removeClass("active");
            $(this).addClass("active");
            localStorage.setItem("article_opinion_" + articleId, "like");
        }
    });

    $(".article__dislike").on("click", function () {
        let articleId = $(this).closest(".article__bottom-right").attr("data-article-id");

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            localStorage.removeItem("article_opinion_" + articleId);
        } else {
            let parent = $(this).closest(".article__bottom-right");
            parent.find(".article__opinion").removeClass("active");
            $(this).addClass("active");
            localStorage.setItem("article_opinion_" + articleId, "dislike");
        }
    });
});


$(document).ready(function() {
    $('.contact__input-others').hide(); // Hide by default
    $('#other_subject').prop('disabled', true); // Disable the input initially

    $('#contact_subject').change(function() {
        if ($(this).val() === 'others') {
            $('.contact__input-others').show();
            $('#other_subject').prop('disabled', false).attr('required', 'required'); // Enable and require the input
        } else {
            $('.contact__input-others').hide();
            $('#other_subject').prop('disabled', true).removeAttr('required'); // Disable and remove required attribute
        }
    });
});
